module.exports = __webpack_public_path__ + "img/editor_preview-4.c3ccfc7.webp";